export default "/static-assets/_next/static/locales/ja/common.c30c4b29cd510cb339f747adb1283dc7.json";